import { Button, Divider, Stack, styled, Typography } from "@mui/material";
import FeatureGroup from "./FeatureGroup";
import { PricingPlan } from "@/types/plans";
import { useAppSelector, useResponsive } from "@/hooks";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, FreeMode, Navigation, Pagination } from "swiper/modules";


const SwiperStyled = styled(Swiper)`
  .swiper-pagination {
    bottom: 46px;
  }
`;

const Plan = ({ plan, onSelect }: { plan: PricingPlan; onSelect: (id: string) => void }) => {
  const { isMobile } = useResponsive();
  const activeOrg = useAppSelector((store) => store.ui.activeOrganization);
  const organization = useAppSelector((store) => store.organizations[activeOrg])

  const updatePlan = () => {
    window.open(`https://wa.me/50587987846?text=Hola,%0A%0AMe gustaría actualizar mi plan actual, que es %2A${organization.plan}%2A, y cambiarlo al plan %2A${plan.title}%2A.%0A%0AMi negocio es: %2A${organization.title}%2A.%0A%0AQuedo atento a los pasos a seguir. ¡Gracias!`
    );
  }

  return (
    <Stack borderRadius={3} border={plan.isActive ? 3 : 2} borderColor={plan.isActive ? plan.accentColor : "divider"} bgcolor="white" overflow="hidden">
      <Stack spacing={2} p={3} paddingTop={6} bgcolor={plan.accentColor} color="white" justifyContent={"flex-end"} alignSelf={"stretch"}>

        <Stack alignItems="center" spacing={1} justifyContent={"space-between"}>
          <Typography variant="h2" color="white" fontSize={"48px"}>
            {plan.title}
          </Typography>
          <Typography color="white" fontSize={"32px"}>
            ${plan.price}
            {plan.priceSuffix}
          </Typography>
        </Stack>

        <Typography
          variant="body1"
          sx={{
            color: "rgba(255, 255, 255, 0.75)",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "24px",
            letterSpacing: "0.15px",
          }}
        >
          {plan.description}
        </Typography>

        <Button
          fullWidth
          variant={plan.isActive ? "outlined" : "contained"}
          color={plan.isActive ? "inherit" : "success"}
          onClick={plan.isActive ? onSelect.bind(null, plan.id) : updatePlan}
          target="_blank"
        >
          {plan.isActive ? "Plan actual" : "Actualizar"}
        </Button>
      </Stack>
      <Stack spacing={2}>
        {isMobile && plan.featureGroups.length > 0 ? (
          <SwiperStyled
            slidesPerView={1}
            spaceBetween={0}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            loop={true}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination, Navigation, FreeMode, Autoplay, EffectFade]}
            effect="fade"
            centeredSlides={true}
            freeMode={true}
          >
            {plan.featureGroups.map((group, i) => (
              <SwiperSlide key={group.title + i}>
                <div style={{ background: "white", height: "100%" }}>
                  <FeatureGroup {...group} />
                </div>
              </SwiperSlide>
            ))}
          </SwiperStyled>
        ) : (
          <Stack>
            {plan.featureGroups.map((group, i) => (
              <Stack key={i} justifyContent={"center"}>
                <FeatureGroup {...group} />
                {group.features.length - 1 ? <Divider /> : null}
              </Stack>
            ))}
          </Stack>
        )}
      </Stack>
      <Stack spacing={2} p={3}>
        <Button
          variant={plan.isActive ? "outlined" : "contained"}
          color={plan.isActive ? "inherit" : "success"}
          onClick={plan.isActive ? onSelect.bind(null, plan.id) : updatePlan}
          target="_blank"
        >
          {plan.isActive ? "Plan actual" : "Actualizar"}
        </Button>
      </Stack>
    </Stack>
  );
};

export default Plan;
